export const ROOM_LAYOUT = {
  BANQUET_60: 'BANQUET_60',
  BANQUET_72: 'BANQUET_72',
  CONFERENCE: 'CONFERENCE',
  H_SQUARE: 'H_SQUARE',
  RECEPTION: 'RECEPTION',
  SCHOOL_ROOM_18: 'SCHOOL_ROOM_18',
  SCHOOL_ROOM_30: 'SCHOOL_ROOM_30',
  TABLET_CHAIR: 'TABLET_CHAIR',
  THEATER: 'THEATER',
  TRADE_SHOW_8_10: 'TRADE_SHOW_8_10',
  TRADE_SHOW_10_X_10: 'TRADE_SHOW_10_X_10',
  U_SHAPE: 'U_SHAPE',
  CRESCENT_ROUNDS_60: 'CRESCENT_ROUNDS_60',
  CRESCENT_ROUNDS_66: 'CRESCENT_ROUNDS_66',
  CRESCENT_ROUNDS_72: 'CRESCENT_ROUNDS_72'
};

export const CHANGE_TYPE = {
  CHANGE_ROOM_SPACE_VALUE: 'CHANGE ROOM SPACE VALUE',
  CHANGE_ATTENDEES_VALUE: 'CHANGE ATTENDEES VALUE'
};

export const SOCIAL_DISTANCING_INPUT_INCREMENT_FEET = 1;
export const SOCIAL_DISTANCING_INPUT_INCREMENT_METERS = 0.5;
export const MINIMUM_SOCIAL_DISTANCING_UNIT_FEET = 1;
export const MINIMUM_SOCIAL_DISTANCING_UNIT_METERS = 0.5;
export const MAXIMUM_SOCIAL_DISTANCING_UNIT_FEET = 50;
export const MAXIMUM_SOCIAL_DISTANCING_UNIT_METERS = 16;
export const DEFAULT_SOCIAL_DISTANCE_IMPERIAL = 6;
export const DEFAULT_SOCIAL_DISTANCE_METRIC = 2;

export const MAX_ATTENDEES = 50000;
export const MAX_ROOM_SPACE = 99999;

export const CONVERSIONS = {
  METRIC_TO_IMPERIAL_CONVERSION_VALUE: 10.76,
  REAR_PROJECTION_SCALING_FACTOR: 0.4,
  ROOM_SPACE_CONFERENCE_METRIC_MAXIMUM: 100,
  ROOM_SPACE_CONFERENCE_IMPERIAL_MAXIMUM: 1000,
  ATTENDEES_CONFERENCE_MAXIMUM: 24,
  ROOM_SPACE_H_SQUARE_METRIC_MAXIMUM: 200,
  ROOM_SPACE_H_SQUARE_IMPERIAL_MAXIMUM: 2000,
  ATTENDEES_H_SQUARE_MAXIMUM: 52,
  ROOM_SPACE_H_SQUARE_METRIC_MINIMUM: 30,
  ROOM_SPACE_H_SQUARE_IMPERIAL_MINIMUM: 300,
  ATTENDEES_H_SQUARE_MINIMUM: 10,
  ROOM_SPACE_TRADE_SHOW_METRIC_MAXIMUM: 150,
  ROOM_SPACE_TRADE_SHOW_IMPERIAL_MAXIMUM: 1500
};
